import { type PageOptions, usePage } from "@/api/pagination";
import DestinationActivityService from "@/api/services/destination_activities";
import type { DestinationActivity } from "@/types";

export function useDestinationActivities(
  destinationId: string | undefined,
  params: PageOptions,
  filters: Record<string, string> = {},
) {
  const scopedFilters = destinationId ? { ...filters, destination_id: destinationId } : filters;

  return usePage<DestinationActivity>(
    ["destination-activities", destinationId, scopedFilters],
    (paginationParams) => DestinationActivityService.getDestinationActivities(paginationParams, scopedFilters),
    params,
  );
}
